export default __webpack_public_path__ + "static/media/undraw_Calendar.14aa1880.svg";